"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _2xko_1 = __importDefault(require("./2xko"));
const rb_1 = __importDefault(require("./rb"));
const iconPacks = [_2xko_1.default, rb_1.default];
exports.default = iconPacks;
